import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DxTextBoxModule, DxValidatorModule, DxNumberBoxModule, DxPopoverModule } from 'devextreme-angular';
import { DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { SvgIconComponent } from '../../../../../../../../components/svg-icon/svg-icon.component';
import { ProjectConfigNodeComponent } from '../../project-config-node.component';
import validationEngine from 'devextreme/ui/validation_engine';
import { Milestone, Phase } from '../../../../../../../../interfaces/entities/project-configuration';

@Component({
    selector: 'app-milestone-project-config-node',
    imports: [
        CommonModule,
        FormsModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxiValidationRuleModule,
        DxNumberBoxModule,
        DxPopoverModule,
        ProjectConfigNodeComponent,
    ],
    templateUrl: './milestone-project-config-node.component.html',
    styleUrl: './milestone-project-config-node.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MilestoneProjectConfigNodeComponent {
  @Input() milestone!: Milestone;
  @Input() phases!: Phase[];
  @Input() itemNumber!: number;
  @Input() isEditing: boolean = false;
  @Input() isNew: boolean = false;
  @Input() isSelected: boolean = false;
  @Input() validationCallback?: (value: string) => boolean;

  @Output() onSave = new EventEmitter<Milestone>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();
  @Output() onStartEdit = new EventEmitter<Milestone>();
  @Output() onMilestoneClick = new EventEmitter<void>();
  @Output() hovering = new EventEmitter<boolean>();

  editData: Milestone | null = null;

  ngOnInit() {
    this.editData = { ...this.milestone };
  }
  // Custom save handler to emit the current milestone name
  handleSave() {
    this.onSave.emit(this.editData);
  }

  // Unique name validation for milestones across all phases
  uniqueNameValidationCallback = (params: any): boolean => {
    const currentName = params?.value || params?.data || params;

    if (!currentName || currentName.trim() === '') {
      return true; // Let required validation handle empty values
    }

    // Check if any other milestone across all phases has the same name (case-insensitive)
    const duplicateExists = this.phases.some(phase => {
      return phase.milestones?.some(otherMilestone => {
        if (otherMilestone.id === this.milestone.id) {
          return false; // Skip current milestone
        }

        return otherMilestone.name && otherMilestone.name.trim().toLowerCase() === currentName.trim().toLowerCase();
      });
    });

    return !duplicateExists;
  };

  onItemClick() {
    if (!this.isEditing) {
      this.onMilestoneClick.emit();
    }
  }

  onEditing() {
    this.editData = { ...this.milestone };
    this.onStartEdit.emit(this.editData!);
  }
}
